import { Injectable, NgZone } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { Observer } from 'rxjs/Observer';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SipWsService {

  socket$: Subscription;
  message: Subject<any> = new Subject();
  TelWS: Subject<any>;
  onOpen: Subject<any> = new Subject();
  private url: string;

  private attemptsNumber = 0;

  constructor ( private zone: NgZone ) { }

  public send ( msg ): void {
    this.TelWS.next( msg );
  }

  create ( url ): void {
    this.url = url;

    let ws = new WebSocket( this.url );

    let observable = new Observable( ( observer: Observer<MessageEvent> ) => {
      ws.onmessage = observer.next.bind( observer );
      ws.onerror = observer.error.bind( observer );
      ws.onclose = observer.complete.bind( observer );
      return ws.close.bind( ws );
    } );

    let observer = {
      next: ( data ) => {
        if ( ws.readyState === WebSocket.OPEN ) {
          ws.send( JSON.stringify( data ) );
        } else if ( ws.readyState == 0 ) {
          this.zone.runOutsideAngular( () => {
            setTimeout( () => {
              this.send( data );
            }, 2000 );
          } );
        }
      }
    };

    this.TelWS = Subject.create( observer, observable );
    this.socket$ = this.TelWS.subscribe( {
      next: ( data ) => {
        let resp = JSON.parse( data.data );
        this.attemptsNumber = 0;
        if ( resp.pong == undefined ) {
          this.message.next( resp );
        }
        this.onOpen.next( true );
      },
      error: ( err ) => {
        console.error( err );
        this.onOpen.next( false );
        this.attemptsNumber = this.attemptsNumber + 1;
        setTimeout( () => {
          this.create( this.url );
        }, this.getTimeToReconnect() );
        this.socket$.unsubscribe();
      },
      complete: () => {
        this.onOpen.next( false );
      }
    } );

    this.zone.runOutsideAngular( () => {
      setInterval( () => {
        this.TelWS.next( {
          'ping': 'true'
        } );
      }, 15000 );
    } );

  }

  public close (): void {
    this.socket$.unsubscribe();
    this.TelWS.complete();
  }

  private getTimeToReconnect(): number {
    if (this.attemptsNumber <= 20) {
      return 5000;
    } else if (this.attemptsNumber > 20 &&  this.attemptsNumber <= 40) {
      return 10000;
    } else if (this.attemptsNumber > 40 && this.attemptsNumber < 70) {
      return 60000;
    } else {
      return 9999999;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/services/sip-ws.service.ts